import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile, isTablet, isIOS } from 'react-device-detect'
import history from '../../../history'

import GenericRow from '../../../GenericComponents/GenericRow'
import GenericLogo from '../../../GenericComponents/GenericLogo'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericColumn from '../../../GenericComponents/GenericColumn'

import { TopBannerImage, TopBannerFadeOut } from '../style/LandingStyle'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'


interface TopBannerInterface { heroVideo: any }

const TopBanner: FC<TopBannerInterface> = ({ heroVideo }) => {

  const pushToLogin = () => {
    history.push("/zaloguj")
  }



  return (
    <GenericRow className="top-banner" justify="space-between">
      <GenericRow zIndex="2" wrap={"wrap"} position="absolute" bottom={isMobile ? "0" : "7%"}>
        <GenericTextSpan fWeight={"bold"} fSize={isMobile ? "3rem" : "4rem"} display="block" width="100%">Zadbaj o siebie,</GenericTextSpan>
        <GenericTextSpan fWeight={"bold"} fSize={isMobile ? "3rem" : "4rem"} display="block" width="100%">trenując w domu</GenericTextSpan>
        <GenericTextSpan margin={"1.25rem"} fWeight={"bold"} fSize={isMobile ? "1.35rem" : "1.2rem"} display="block" width="100%">Dołącz do ponad 100 000 kobiet, które odmieniły swoje życie

        </GenericTextSpan>
        <GenericColumn margin={"2rem 1.25rem .25rem 1.25rem"}>

          <GenericTextSpan margin={"0 0 2px 0"} fSize="1.02rem" fWeight="bold">Nie masz konta?</GenericTextSpan>
          <GenericButton onClick={pushToLogin} justify="center" tAlign="center" className="standard" padding="15px 50px" borderRadius={"30px"} width={isMobile ? "40%" : "max-content"}>Zarejestruj się</GenericButton>
        </GenericColumn>
      </GenericRow>

      <GenericColumn overflow="hidden" className={`hero-column-left ${isTablet ? "isTablet" : ""}`} width="calc(100% - 540px)">
        <TopBannerImage className={`left-image ${isTablet ? "isTablet" : ""} ${isIOS ? "ios" : ""}`} />
      </GenericColumn>
      <GenericColumn overflow="hidden" className={`hero-column-right ${isTablet ? "isTablet" : ""}`} width="100vw">
        <TopBannerImage className={`right-image ${isIOS ? "ios" : ""} ${isTablet ? "isTablet" : ""}`} >
          <video autoPlay playsInline
            webkit-playsinline={true}
            webkit-playsInline loop muted poster="https://i.vimeocdn.com/video/1361739447-893912596fa0a373655b1e2629d33f32da1a0a76a200172b7f74b871fd64ff0d-d_1920x1080?r=pad" src={"https://player.vimeo.com/progressive_redirect/playback/671982529/rendition/1080p/1080p.mp4?loc=external&oauth2_token_id=1354788489&signature=6072ce04bc40f107db1b1ddd7861429ff01cda3d0e6889a83c4ce99b45956922"}></video>

        </TopBannerImage>
      </GenericColumn>

      <TopBannerFadeOut />
    </GenericRow>
  )
}

export default TopBanner
